import Grid from '@mui/material/Grid';
import { ODSDialog, ODSDialogContent } from '@telekom-ods/react-ui-kit';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import Alert from '../Alert';
import Button from '../Buttons/Button';

import type { ModalProps } from '@/types/formTypes';

const Modal = ({
  open = true,
  hideActions = false,
  disabled = false,
  title,
  submitLabel,
  onClose,
  onSubmit = null,
  children = null,
  error = null,
  width = 'auto',
  height = 'auto',
  maxWidth = 'md',
}: ModalProps): ReactNode => {
  const intl = useIntl();
  const resolvedSubmitLabel = submitLabel ?? intl.formatMessage({ id: 'save' });

  const actionSlot = !hideActions && (
    <Grid
      container
      spacing={1}
      justifyContent='flex-end'
      maxWidth={maxWidth}
    >
      <Grid item>
        <Button
          variant='secondary'
          onClick={onClose}
          label={intl.formatMessage({ id: 'cancel' })}
        />
      </Grid>
      {onSubmit && (
        <Grid item>
          <Button
            variant='primary'
            disabled={disabled}
            onClick={onSubmit}
            label={resolvedSubmitLabel}
          />
        </Grid>
      )}
    </Grid>
  );

  return (
    <ODSDialog
      open={open}
      onOpenChange={newOpen => {
        if (!newOpen) {
          onClose();
        }
      }}
      onClose={onClose}
      style={{ margin: '10px' }}
    >
      <ODSDialogContent
        headerText={title}
        actionSlot={actionSlot}
        style={{ width, ...(height !== 'auto' && { height }) }}
        bodyText={
          error ? (
            <Alert
              mode='error'
              title={intl.formatMessage({ id: error.message })}
              text=''
            />
          ) : (
            children
          )
        }
      />
    </ODSDialog>
  );
};

export default Modal;
